import { useI18n } from '~/common/context';
import { IOrder, IOrderServiceItem } from '@wyz/types';
import { Flex, Icon, Text } from '@wyz/ui';
import { ExtraServiceItem } from '~/purchase/components';
import { SERVICE_EAN, OrderHelpers } from '~/purchase/helpers';

type Props = {
  order: IOrder;
  serviceItem: IOrderServiceItem;
};
const ServiceItem = ({ order, serviceItem }: Props) => {
  const { t } = useI18n();

  return (
    <>
      <ExtraServiceItem
        item={{
          quantity: serviceItem.quantity,
          unitPrice: serviceItem.priceCustomer,
          discount: serviceItem.discount,
          total: serviceItem.excludedTaxesAmount,
        }}
        currency={order.currency}
      >
        <Flex alignItems='center' className='gap-2'>
          <Icon
            className='text-brand-blue-alt-normal'
            icon={OrderHelpers.getServiceIcon(order, serviceItem.ean)}
          />
          <Text
            color='tertiary'
            weight='bold'
            heading='normal'
            className='flex-grow-1'
            id='service-type'
          >
            {serviceItem.ean === SERVICE_EAN.J0_DELIVERY
              ? t(
                  order.todayDelivery
                    ? 'app.purchase.orders.table.j0_today_delivery'
                    : 'app.purchase.orders.table.j0_morning_delivery',
                )
              : (serviceItem.translatedDescription ?? serviceItem.description)}
          </Text>
        </Flex>
      </ExtraServiceItem>
    </>
  );
};

export default ServiceItem;
